<div class="module-whatsapp" [ngClass]="{'hide': page == '/negocios'}" (click)="open()" *ngIf="template == 'fixo'">
  <div class="content">
        <span>Chama no <strong>WhatsApp!</strong></span>
        <strong class="number">{{data.params.telefone}}</strong>
        <div class="icon">
          <img src="/images/icons/whatsapp.svg" alt="WhatsApp" width="15px" height="15px" />
        </div>  
  </div> 
  <div class="content mobile">
      <div class="icon">
          <img src="/images/icons/whatsapp.svg" alt="WhatsApp" width="15px" height="15px" />
      </div>  
  </div>   
</div>  
<div class="module-whatsapp-help" (click)="open()" *ngIf="template == 'help'">
    <div class="content">
        <div class="icon">
            <img src="/images/icons/whatsapp.svg" alt="WhatsApp" width="50px" height="50px" />
        </div> 
        <div class="content-text">
            <h3>Tire as suas dúvidas pelo WhatsApp</h3>
            <a href="javascript::void();">
                Clique aqui :)
            </a>   
        </div>
    </div>
</div>  
<div class="module-whatsapp-greenhouse-school" (click)="open()" *ngIf="template == 'greenhouse-school'">
    <div class="content">
        <i class="material-icons">whatsapp</i>
        <span>Clique Aqui</span>
    </div>
</div>